import { useMemo } from "react";
import { useCurrentTenant } from "core/features/auth/tenant.store";
import moment from "moment";
import { View, Image, Text, Page } from "@react-pdf/renderer";
import { makePdfStyleSheet } from "./styles";
import { makeImageSrcObject } from "./util";

interface PDFCapaProps {
  logoUrl: string;
  title?: string | null;
  dataInicio?: string | null;
  dataFim?: string | null;
  orientation?: "retrato" | "paisagem";
  includePeriodo?: boolean;
}

function PDFCapa({
  title,
  dataInicio,
  dataFim,
  logoUrl,
  orientation = "retrato",
  includePeriodo = true,
}: PDFCapaProps) {
  const { tenant } = useCurrentTenant();

  const periodo = useMemo(
    () =>
      !dataInicio
        ? "Todos os meses"
        : `De ${moment(dataInicio).format("DD/MM/YYYY")} até ${moment(
            dataFim
          ).format("DD/MM/YYYY")}`,
    [dataInicio, dataFim]
  );
  const styles = useMemo(() => makePdfStyleSheet(), []);

  return (
    <Page
      size="A4"
      wrap
      orientation={orientation === "paisagem" ? "landscape" : "portrait"}
      minPresenceAhead={1}
    >
      <View style={styles.cover}>
        {title ? <Text style={styles.coverTitle}>{title}</Text> : null}
        <Text style={styles.coverTenant}>{tenant.nome}</Text>

        <Image src={makeImageSrcObject(logoUrl)} style={styles.logoCover} />

        {includePeriodo ? (
          <Text style={styles.coverDate}>{periodo}</Text>
        ) : null}
      </View>
    </Page>
  );
}

export default PDFCapa;
